// react
import { useCallback } from 'react';
import styled from 'styled-components';

// components
import { Icon } from '@/components/atoms';

interface CopyTextProps {
  className?: string;
  value?: string;
  onCopy?: () => void;
}

/**
 * CopyText is a component that displays text that can be copied.
 */
export const CopyText = ({ className, value, onCopy }: CopyTextProps) => {
  // methods
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value || '');
    onCopy?.();
  }, []);

  return (
    <Wrapper className={className}>
      <CopyValue>{value}</CopyValue>
      <IconButton onClick={handleCopy}>
        <Icon icon='copy' />
      </IconButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing[8]};
  border: 1px solid ${(props) => props.theme.color.neutral[50]};
  background: ${(props) => props.theme.color.neutral[20]};
  color: ${(props) => props.theme.color.neutral[90]};
  border-radius: 4px;
`;

const CopyValue = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: ${(props) => props.theme.spacing[8]};
  padding-right: 0;
`;

const IconButton = styled.button`
  all: unset;
  cursor: pointer;
  padding: ${(props) => props.theme.spacing[8]};
  padding-left: 0;
`;

CopyText.displayName = 'CopyText';

export default CopyText;
